var map = {
	"./bg-about-us-contact-us.png": 2818,
	"./bg-about-us-section1.png": 4165,
	"./bg-about-us-subheader.png": 4946,
	"./bg-home-about-us.png": 8840,
	"./btn-back-top.png": 142,
	"./btn-next.png": 9622,
	"./captcha.png": 8304,
	"./contact-us.png": 2977,
	"./default.png": 4741,
	"./directory.png": 7831,
	"./double-quotation.png": 7306,
	"./dummy-event.png": 4901,
	"./dummy-map.png": 9784,
	"./dummy-poi.png": 3885,
	"./dummy2.png": 4222,
	"./dummy4.png": 7096,
	"./explore-orchard.png": 9053,
	"./fb-icon.png": 7152,
	"./floorguide.png": 6950,
	"./floorguideold.png": 7795,
	"./footer-background.png": 112,
	"./header.png": 3871,
	"./home.png": 773,
	"./homebackground1.png": 6640,
	"./icons/arrow-left-small.png": 2772,
	"./icons/arrow-right-small.png": 6073,
	"./ig-icon.png": 6632,
	"./info-circle.png": 7499,
	"./logo.png": 3153,
	"./search.png": 1060,
	"./tiktok-icon.png": 2858,
	"./whats-on.png": 9597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;